<template>
  <section class="d-flex flex-column h-full">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    >
    </TopAppBar>
    <TopAppBarDrawer
      :isDrawerOpen="isDrawerOpen"
      @closeDrawer="closeDrawer"
    ></TopAppBarDrawer>
    <div class="flex-grow-1 scroll-y bg-white">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
/**
 * 마이페이지 메인 컴포넌트(mypage main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";

export default {
  name: "",

  components: {
    TopAppBar,
    TopAppBarDrawer,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route: {
      handler: function (to, from) {
        if (to.name === "MemberProfilePatten" || to.name === "MemberProfilePicture") {
          if(to.name === 'Withdrawal') {
            this.setTopAppBarBackSearch(this.$t('S10059'))
            this.title = this.$t('S10059');
          }
          this.leftBtnMode = "arrow_back";
          this.leftBtnMethod = () => {
            this.$router.push("/home");
          };
        } else if (to.name === "Withdrawal") {
          this.leftBtnMode = "arrow_back";
          this.leftBtnMethod = () => {
            this.$router.go(-1);
          }
        } else if (to.name === "MemberDetail") {
          this.leftBtnMode = "menu";
          this.leftBtnMethod = this.openDrawer;
        } else {
          this.ç = "arrow_back";
          // move to home page
          this.$router.push("/home");
          this.leftBtnMethod = () => {
            this.$router.push("/home");
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      isDrawerOpen: false,
    }
  },

  methods: {
    openDrawer() {
      this.isDrawerOpen = true;
    },

    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>